export interface DealTypePreference {
	name: string;
	matchedLenders: number;
	lowestRate: number;
	lowLoanAmount: number;
	highLoanAmount: number;
	amortization: string;
	selected: boolean;
	isLimitedByCollateral: boolean;
}

export type LoanOptionType = keyof typeof LoanOptionTypeMap;
export const LoanOptionTypeMap = {
	CashFlowBank: 'Cash Flow Bank',
	SeniorCashNonBank: 'Senior Cash Non-Bank Lending',
	JuniorCashNonBank: 'Junior Cash Non-Bank Lending',
	AssetBasedInvArBank: 'Asset Based Commercial Bank AR/Inv',
	AssetBasedInvArNonBank: 'Asset Based Non-Bank Lending AR/Inv',
	AssetBasedFixedBank: 'Asset Based Commercial Bank Fixed Assets',
	AssetBasedFixedNonBank: 'Asset Based Non-Bank Lending Fixed Assets',
	SmallGovernment: 'Small Government Backed Loans',
	LargeGovernment: 'Rural Government Backed Loans',
	VentureBank: 'Venture & Recurring Revenue Loans Bank',
	VentureNonBank: 'Venture & Recurring Revenue Loans Non-Bank',
	PoFinancing: 'Purchase Order Financing',
	Factoring: 'Factoring',
	InventoryOnly: 'Asset Based Non-Bank Lending Inventory Only',
	LenderFinanceBank: 'Lender Finance - Bank',
	LenderFinanceNonBank: 'Lender Finance - Non-Bank',
	FloorplanFinanceBank: 'Floorplan Finance - Bank',
	FloorplanFinanceNonBank: 'Floorplan Finance - Non-Bank',
	BridgeLoanNonBank: 'Bridge Loan',
};
